export const DictionaryPhotoshop_zh_TW = [
    {
        id: 1,
        label: 'Photoshop > 關於 Photoshop...',
        placement: 'MenuBar',
        name: '關於 Photoshop...',
    },
    {
        id: 10,
        label: '檔案 > 開新檔案...',
        placement: 'MenuBar',
        name: '開新檔案...',
    },
    {
        id: 20,
        label: '檔案 > 開啟舊檔...',
        placement: 'MenuBar',
        name: '開啟舊檔...',
    },
    {
        id: 22,
        label: '檔案 > 開啟為智慧型物件...',
        placement: 'MenuBar',
        name: '開啟為智慧型物件...',
    },
    {
        id: 30,
        label: '檔案 > 儲存檔案',
        placement: 'MenuBar',
        name: '儲存檔案',
    },
    {
        id: 31,
        label: '檔案 > 關閉檔案',
        placement: 'MenuBar',
        name: '關閉檔案',
    },
    {
        id: 32,
        label: '檔案 > 另存新檔...',
        placement: 'MenuBar',
        name: '另存新檔...',
    },
    {
        id: 33,
        label: '檔案 > 儲存副本...',
        placement: 'MenuBar',
        name: '儲存副本...',
    },
    {
        id: 34,
        label: '檔案 > 回復至前次儲存',
        placement: 'MenuBar',
        name: '回復至前次儲存',
    },
    {
        id: 36,
        label: 'Photoshop > 結束 Photoshop',
        placement: 'MenuBar',
        name: '結束 Photoshop',
    },
    {
        id: 37,
        label: '檔案 > 全部關閉',
        placement: 'MenuBar',
        name: '全部關閉',
    },
    {
        id: 46,
        label: '檔案 > 關閉其他項目',
        placement: 'MenuBar',
        name: '關閉其他項目',
    },
    {
        id: 101,
        label: '編輯 > 還原(O)',
        placement: 'MenuBar',
        name: '還原(O)',
    },
    {
        id: 103,
        label: '編輯 > 剪下',
        placement: 'MenuBar',
        name: '剪下',
    },
    {
        id: 104,
        label: '編輯 > 拷貝',
        placement: 'MenuBar',
        name: '拷貝',
    },
    {
        id: 105,
        label: '編輯 > 貼上',
        placement: 'MenuBar',
        name: '貼上',
    },
    {
        id: 106,
        label: '編輯 > 清除',
        placement: 'MenuBar',
        name: '清除',
    },
    {
        id: 132,
        label: '編輯 > 重做(O)',
        placement: 'MenuBar',
        name: '重做(O)',
    },
    {
        id: 133,
        label: '編輯 > 切換最後狀態',
        placement: 'MenuBar',
        name: '切換最後狀態',
    },
    {
        id: 177,
        label: '檔案 > 列印一份拷貝',
        placement: 'MenuBar',
        name: '列印一份拷貝',
    },
    {
        id: 1001,
        label: '視窗 > 排列順序 > 新增視窗',
        placement: 'MenuBar',
        name: '新增視窗',
    },
    {
        id: 1002,
        label: '檢視 > 尺標',
        placement: 'MenuBar',
        name: '尺標',
    },
    {
        id: 1004,
        label: '檢視 > 放大顯示',
        placement: 'MenuBar',
        name: '放大顯示',
    },
    {
        id: 1005,
        label: '檢視 > 縮小顯示',
        placement: 'MenuBar',
        name: '縮小顯示',
    },
    {
        id: 1006,
        label: '影像 > 模式 > 點陣圖(B)',
        placement: 'MenuBar',
        name: '點陣圖(B)',
    },
    {
        id: 1007,
        label: '影像 > 模式 > 灰階(G)',
        placement: 'MenuBar',
        name: '灰階(G)',
    },
    {
        id: 1008,
        label: '影像 > 模式 > 雙色調(D)',
        placement: 'MenuBar',
        name: '雙色調(D)',
    },
    {
        id: 1009,
        label: '影像 > 模式 > 索引色(I)',
        placement: 'MenuBar',
        name: '索引色(I)',
    },
    {
        id: 1010,
        label: '影像 > 模式 > RGB 色彩',
        placement: 'MenuBar',
        name: 'RGB 色彩',
    },
    {
        id: 1011,
        label: '影像 > 模式 > CMYK 色彩',
        placement: 'MenuBar',
        name: 'CMYK 色彩',
    },
    {
        id: 1014,
        label: '影像 > 模式 > 多重色版',
        placement: 'MenuBar',
        name: '多重色版',
    },
    {
        id: 1016,
        label: '選取 > 取消選取(D)',
        placement: 'MenuBar',
        name: '取消選取(D)',
    },
    {
        id: 1017,
        label: '選取 > 全部(A)',
        placement: 'MenuBar',
        name: '全部(A)',
    },
    {
        id: 1018,
        label: '選取 > 反轉',
        placement: 'MenuBar',
        name: '反轉',
    },
    {
        id: 1019,
        label: '濾鏡 > 上次濾鏡效果',
        placement: 'MenuBar',
        name: '上次濾鏡效果',
    },
    {
        id: 1021,
        label: '視窗 > 色版',
        placement: 'MenuBar',
        name: '色版',
    },
    {
        id: 1025,
        label: '視窗 > 筆刷設定',
        placement: 'MenuBar',
        name: '筆刷設定',
    },
    {
        id: 1029,
        label: '編輯 > 定義筆刷預設集...',
        placement: 'MenuBar',
        name: '定義筆刷預設集...',
    },
    {
        id: 1030,
        label: '影像 > 影像尺寸...',
        placement: 'MenuBar',
        name: '影像尺寸...',
    },
    {
        id: 1031,
        label: '影像 > 版面尺寸...',
        placement: 'MenuBar',
        name: '版面尺寸...',
    },
    {
        id: 1032,
        label: '檔案 > 置入嵌入的物件...',
        placement: 'MenuBar',
        name: '置入嵌入的物件...',
    },
    {
        id: 1033,
        label: '選取 > 連續相近色',
        placement: 'MenuBar',
        name: '連續相近色',
    },
    {
        id: 1034,
        label: '選取 > 相近色',
        placement: 'MenuBar',
        name: '相近色',
    },
    {
        id: 1035,
        label: '選取 > 修改 > 邊界...',
        placement: 'MenuBar',
        name: '邊界...',
    },
    {
        id: 1036,
        label: '選取 > 修改 > 羽化...',
        placement: 'MenuBar',
        name: '羽化...',
    },
    {
        id: 1037,
        label: '圖層 > 修邊 > 修飾外緣...',
        placement: 'MenuBar',
        name: '修飾外緣...',
    },
    {
        id: 1038,
        label: '編輯 > 定義圖樣...',
        placement: 'MenuBar',
        name: '定義圖樣...',
    },
    {
        id: 1040,
        label: '編輯 > 選擇性貼上 > 貼入範圍內',
        placement: 'MenuBar',
        name: '貼入範圍內',
    },
    {
        id: 1042,
        label: '編輯 > 填滿...',
        placement: 'MenuBar',
        name: '填滿...',
    },
    {
        id: 1043,
        label: '編輯 > 筆畫...',
        placement: 'MenuBar',
        name: '筆畫...',
    },
    {
        id: 1044,
        label: '影像 > 裁切',
        placement: 'MenuBar',
        name: '裁切',
    },
    {
        id: 1045,
        label: '影像 > 模式 > 色彩表...',
        placement: 'MenuBar',
        name: '色彩表...',
    },
    {
        id: 1046,
        label: '視窗 > 顏色',
        placement: 'MenuBar',
        name: '顏色',
    },
    {
        id: 1052,
        label: '影像 > 模式 > Lab 色彩',
        placement: 'MenuBar',
        name: 'Lab 色彩',
    },
    {
        id: 1055,
        label: '視窗 > 資訊',
        placement: 'MenuBar',
        name: '資訊',
    },
    {
        id: 1058,
        label: '視窗 > 仿製來源',
        placement: 'MenuBar',
        name: '仿製來源',
    },
    {
        id: 1065,
        label: '視窗 > 路徑',
        placement: 'MenuBar',
        name: '路徑',
    },
    {
        id: 1080,
        label: '影像 > 修剪...',
        placement: 'MenuBar',
        name: '修剪...',
    },
    {
        id: 1081,
        label: '影像 > 全部顯現',
        placement: 'MenuBar',
        name: '全部顯現',
    },
    {
        id: 1093,
        label: '影像 > 補漏白...',
        placement: 'MenuBar',
        name: '補漏白...',
    },
    {
        id: 1098,
        label: '視窗 > 圖層',
        placement: 'MenuBar',
        name: '圖層',
    },
    {
        id: 1099,
        label: '圖層 > 新增 > 圖層...',
        placement: 'MenuBar',
        name: '圖層...',
    },
    {
        id: 1100,
        label: '圖層 > 刪除 > 圖層(L)',
        placement: 'MenuBar',
        name: '圖層(L)',
    },
    {
        id: 1103,
        label: '圖層 > 圖層內容選項...',
        placement: 'MenuBar',
        name: '圖層內容選項...',
    },
    {
        id: 1105,
        label: '檢視 > 校樣色彩',
        placement: 'MenuBar',
        name: '校樣色彩',
    },
    {
        id: 1106,
        label: '檢視 > 色域警告',
        placement: 'MenuBar',
        name: '色域警告',
    },
    {
        id: 1107,
        label: '編輯 > 拷貝合併',
        placement: 'MenuBar',
        name: '拷貝合併',
    },
    {
        id: 1108,
        label: '選取 > 修改 > 平滑...',
        placement: 'MenuBar',
        name: '平滑...',
    },
    {
        id: 1109,
        label: '選取 > 修改 > 擴張...',
        placement: 'MenuBar',
        name: '擴張...',
    },
    {
        id: 1110,
        label: '選取 > 修改 > 縮減...',
        placement: 'MenuBar',
        name: '縮減...',
    },
    {
        id: 1111,
        label: '視窗 > 選項',
        placement: 'MenuBar',
        name: '選項',
    },
    {
        id: 1112,
        label: '檢視 > 像素外觀比例校正',
        placement: 'MenuBar',
        name: '像素外觀比例校正',
    },
    {
        id: 1114,
        label: '圖層 > 隱藏圖層',
        placement: 'MenuBar',
        name: '隱藏圖層',
    },
    {
        id: 1115,
        label: '選取 > 選取並遮住...',
        placement: 'MenuBar',
        name: '選取並遮住...',
    },
    {
        id: 1119,
        label: '視窗 > 色票',
        placement: 'MenuBar',
        name: '色票',
    },
    {
        id: 1134,
        label: '影像 > 複製...',
        placement: 'MenuBar',
        name: '複製...',
    },
    {
        id: 1135,
        label: '圖層 > 複製圖層...',
        placement: 'MenuBar',
        name: '複製圖層...',
    },
    {
        id: 1137,
        label: '檔案 > 檔案資訊...',
        placement: 'MenuBar',
        name: '檔案資訊...',
    },
    {
        id: 1139,
        label: '圖層 > 合併可見圖層',
        placement: 'MenuBar',
        name: '合併可見圖層',
    },
    {
        id: 1141,
        label: '圖層 > 影像平面化',
        placement: 'MenuBar',
        name: '影像平面化',
    },
    {
        id: 1152,
        label: '選取 > 顏色範圍…',
        placement: 'MenuBar',
        name: '顏色範圍…',
    },
    {
        id: 1153,
        label: '影像 > 套用影像...',
        placement: 'MenuBar',
        name: '套用影像...',
    },
    {
        id: 1154,
        label: '編輯 > 淡化(D)...',
        placement: 'MenuBar',
        name: '淡化(D)...',
    },
    {
        id: 1156,
        label: '圖層 > 圖層遮色片 > 全部隱藏',
        placement: 'MenuBar',
        name: '全部隱藏',
    },
    {
        id: 1157,
        label: '圖層 > 圖層遮色片 > 全部顯現',
        placement: 'MenuBar',
        name: '全部顯現',
    },
    {
        id: 1158,
        label: '圖層 > 圖層遮色片 > 顯現選取範圍',
        placement: 'MenuBar',
        name: '顯現選取範圍',
    },
    {
        id: 1159,
        label: '圖層 > 圖層遮色片 > 啟動(B)',
        placement: 'MenuBar',
        name: '啟動(B)',
    },
    {
        id: 1161,
        label: '影像 > 模式 > 8 位元/色版(A)',
        placement: 'MenuBar',
        name: '8 位元/色版(A)',
    },
    {
        id: 1162,
        label: '影像 > 模式 > 16 位元/色版(N)',
        placement: 'MenuBar',
        name: '16 位元/色版(N)',
    },
    {
        id: 1163,
        label: '視窗 > 導覽器',
        placement: 'MenuBar',
        name: '導覽器',
    },
    {
        id: 1166,
        label: '圖層 > 合併圖層(E)',
        placement: 'MenuBar',
        name: '合併圖層(E)',
    },
    {
        id: 1167,
        label: '視窗 > 圖層構圖',
        placement: 'MenuBar',
        name: '圖層構圖',
    },
    {
        id: 1168,
        label: '圖層 > 圖層遮色片 > 隱藏選取範圍',
        placement: 'MenuBar',
        name: '隱藏選取範圍',
    },
    {
        id: 1169,
        label: '檔案 > 自動 > 建立快捷批次處理...',
        placement: 'MenuBar',
        name: '建立快捷批次處理...',
    },
    {
        id: 1170,
        label: '視窗 > 動作',
        placement: 'MenuBar',
        name: '動作',
    },
    {
        id: 1180,
        label: '檔案 > 自動 > 批次處理...',
        placement: 'MenuBar',
        name: '批次處理...',
    },
    {
        id: 1188,
        label: '視窗 > 時間軸',
        placement: 'MenuBar',
        name: '時間軸',
    },
    {
        id: 1190,
        label: '檢視 > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: '檢視 > 列印尺寸',
        placement: 'MenuBar',
        name: '列印尺寸',
    },
    {
        id: 1192,
        label: '檢視 > 顯示全頁',
        placement: 'MenuBar',
        name: '顯示全頁',
    },
    {
        id: 1194,
        label: '視窗 > 工具',
        placement: 'MenuBar',
        name: '工具',
    },
    {
        id: 1195,
        label: '檢視 > 全頁顯示工作區域',
        placement: 'MenuBar',
        name: '全頁顯示工作區域',
    },
    {
        id: 1199,
        label: '視窗 > 步驟記錄',
        placement: 'MenuBar',
        name: '步驟記錄',
    },
    {
        id: 1200,
        label: '選取 > 載入選取範圍...',
        placement: 'MenuBar',
        name: '載入選取範圍...',
    },
    {
        id: 1202,
        label: '檢視 > 像素外觀比例 > 自訂像素外觀比例...',
        placement: 'MenuBar',
        name: '自訂像素外觀比例...',
    },
    {
        id: 1203,
        label: '檢視 > 像素外觀比例 > 刪除像素外觀比例...',
        placement: 'MenuBar',
        name: '刪除像素外觀比例...',
    },
    {
        id: 1204,
        label: '檢視 > 像素外觀比例 > 重設像素外觀比例...',
        placement: 'MenuBar',
        name: '重設像素外觀比例...',
    },
    {
        id: 1205,
        label: '檢視 > 像素外觀比例 > 正方形',
        placement: 'MenuBar',
        name: '正方形',
    },
    {
        id: 1206,
        label: '影像 > 模式 > 32 位元/色版',
        placement: 'MenuBar',
        name: '32 位元/色版',
    },
    {
        id: 1211,
        label: '編輯 > 預設集 > 遷移預設集',
        placement: 'MenuBar',
        name: '遷移預設集',
    },
    {
        id: 1212,
        label: '編輯 > 指定描述檔...',
        placement: 'MenuBar',
        name: '指定描述檔...',
    },
    {
        id: 1213,
        label: '編輯 > 轉換為描述檔(V)...',
        placement: 'MenuBar',
        name: '轉換為描述檔(V)...',
    },
    {
        id: 1214,
        label: '編輯 > 預設集 > 預設集管理員...',
        placement: 'MenuBar',
        name: '預設集管理員...',
    },
    {
        id: 1215,
        label: '編輯 > Adobe PDF 預設集...',
        placement: 'MenuBar',
        name: 'Adobe PDF 預設集...',
    },
    {
        id: 1217,
        label: '檢視 > 實際尺寸',
        placement: 'MenuBar',
        name: '實際尺寸',
    },
    {
        id: 1223,
        label: '文字 > 文字排列方向 > 橫排',
        placement: 'MenuBar',
        name: '橫排',
    },
    {
        id: 1224,
        label: '文字 > 文字排列方向 > 直排',
        placement: 'MenuBar',
        name: '直排',
    },
    {
        id: 1228,
        label: '文字 > 建立工作路徑',
        placement: 'MenuBar',
        name: '建立工作路徑',
    },
    {
        id: 1229,
        label: '文字 > 轉換為形狀',
        placement: 'MenuBar',
        name: '轉換為形狀',
    },
    {
        id: 1231,
        label: '圖層 > 對齊 > 頂端邊緣',
        placement: 'MenuBar',
        name: '頂端邊緣',
    },
    {
        id: 1232,
        label: '圖層 > 對齊 > 底部邊緣',
        placement: 'MenuBar',
        name: '底部邊緣',
    },
    {
        id: 1233,
        label: '圖層 > 對齊 > 垂直居中',
        placement: 'MenuBar',
        name: '垂直居中',
    },
    {
        id: 1234,
        label: '圖層 > 對齊 > 左側邊緣',
        placement: 'MenuBar',
        name: '左側邊緣',
    },
    {
        id: 1235,
        label: '圖層 > 對齊 > 右側邊緣',
        placement: 'MenuBar',
        name: '右側邊緣',
    },
    {
        id: 1236,
        label: '圖層 > 對齊 > 水平居中',
        placement: 'MenuBar',
        name: '水平居中',
    },
    {
        id: 1237,
        label: '編輯 > 自動對齊圖層...',
        placement: 'MenuBar',
        name: '自動對齊圖層...',
    },
    {
        id: 1238,
        label: '編輯 > 自動混合圖層...',
        placement: 'MenuBar',
        name: '自動混合圖層...',
    },
    {
        id: 1239,
        label: '圖層 > 均分 > 垂直',
        placement: 'MenuBar',
        name: '垂直',
    },
    {
        id: 1241,
        label: '圖層 > 均分 > 頂端邊緣',
        placement: 'MenuBar',
        name: '頂端邊緣',
    },
    {
        id: 1242,
        label: '圖層 > 均分 > 底部邊緣',
        placement: 'MenuBar',
        name: '底部邊緣',
    },
    {
        id: 1243,
        label: '圖層 > 均分 > 垂直居中',
        placement: 'MenuBar',
        name: '垂直居中',
    },
    {
        id: 1245,
        label: '圖層 > 均分 > 左側邊緣',
        placement: 'MenuBar',
        name: '左側邊緣',
    },
    {
        id: 1246,
        label: '圖層 > 均分 > 右側邊緣',
        placement: 'MenuBar',
        name: '右側邊緣',
    },
    {
        id: 1247,
        label: '圖層 > 均分 > 水平居中',
        placement: 'MenuBar',
        name: '水平居中',
    },
    {
        id: 1249,
        label: '圖層 > 均分 > 水平',
        placement: 'MenuBar',
        name: '水平',
    },
    {
        id: 1281,
        label: '選取 > 儲存選取範圍...',
        placement: 'MenuBar',
        name: '儲存選取範圍...',
    },
    {
        id: 1284,
        label: '檢視 > 水平翻轉',
        placement: 'MenuBar',
        name: '水平翻轉',
    },
    {
        id: 1285,
        label: '檢視 > 圖樣預視',
        placement: 'MenuBar',
        name: '圖樣預視',
    },
    {
        id: 1292,
        label: '圖層 > 圖層遮色片 > 來自透明區域',
        placement: 'MenuBar',
        name: '來自透明區域',
    },
    {
        id: 1295,
        label: '圖層 > 修邊 > 顏色淨化...',
        placement: 'MenuBar',
        name: '顏色淨化...',
    },
    {
        id: 1297,
        label: '編輯 > 選擇性貼上 > 就地貼上',
        placement: 'MenuBar',
        name: '就地貼上',
    },
    {
        id: 1299,
        label: '檢視 > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: '圖層 > 圖層樣式 > 陰影...',
        placement: 'MenuBar',
        name: '陰影...',
    },
    {
        id: 1302,
        label: '圖層 > 圖層樣式 > 內陰影...',
        placement: 'MenuBar',
        name: '內陰影...',
    },
    {
        id: 1303,
        label: '圖層 > 圖層樣式 > 外光暈...',
        placement: 'MenuBar',
        name: '外光暈...',
    },
    {
        id: 1304,
        label: '圖層 > 圖層樣式 > 內光暈...',
        placement: 'MenuBar',
        name: '內光暈...',
    },
    {
        id: 1305,
        label: '圖層 > 圖層樣式 > 斜角和浮雕...',
        placement: 'MenuBar',
        name: '斜角和浮雕...',
    },
    {
        id: 1306,
        label: '圖層 > 圖層樣式 > 隱藏全部效果',
        placement: 'MenuBar',
        name: '隱藏全部效果',
    },
    {
        id: 1307,
        label: '圖層 > 圖層樣式 > 整體光源...',
        placement: 'MenuBar',
        name: '整體光源...',
    },
    {
        id: 1308,
        label: '圖層 > 圖層樣式 > 建立圖層',
        placement: 'MenuBar',
        name: '建立圖層',
    },
    {
        id: 1312,
        label: '圖層 > 圖層樣式 > 緞面...',
        placement: 'MenuBar',
        name: '緞面...',
    },
    {
        id: 1313,
        label: '圖層 > 圖層樣式 > 筆畫...',
        placement: 'MenuBar',
        name: '筆畫...',
    },
    {
        id: 1314,
        label: '圖層 > 圖層樣式 > 拷貝圖層樣式',
        placement: 'MenuBar',
        name: '拷貝圖層樣式',
    },
    {
        id: 1315,
        label: '圖層 > 圖層樣式 > 貼上圖層樣式',
        placement: 'MenuBar',
        name: '貼上圖層樣式',
    },
    {
        id: 1327,
        label: '圖層 > 圖層樣式 > 縮放效果...',
        placement: 'MenuBar',
        name: '縮放效果...',
    },
    {
        id: 1331,
        label: '圖層 > 圖層樣式 > 混合選項...',
        placement: 'MenuBar',
        name: '混合選項...',
    },
    {
        id: 1335,
        label: '圖層 > 圖層樣式 > 顏色覆蓋...',
        placement: 'MenuBar',
        name: '顏色覆蓋...',
    },
    {
        id: 1336,
        label: '圖層 > 圖層樣式 > 漸層覆蓋...',
        placement: 'MenuBar',
        name: '漸層覆蓋...',
    },
    {
        id: 1337,
        label: '圖層 > 圖層樣式 > 圖樣覆蓋...',
        placement: 'MenuBar',
        name: '圖樣覆蓋...',
    },
    {
        id: 1339,
        label: '圖層 > 圖層樣式 > 清除圖層樣式',
        placement: 'MenuBar',
        name: '清除圖層樣式',
    },
    {
        id: 1355,
        label: '視窗 > 備註',
        placement: 'MenuBar',
        name: '備註',
    },
    {
        id: 1382,
        label: '視窗 > 色階分佈圖',
        placement: 'MenuBar',
        name: '色階分佈圖',
    },
    {
        id: 1396,
        label: '視窗 > 筆刷',
        placement: 'MenuBar',
        name: '筆刷',
    },
    {
        id: 1429,
        label: '增效模組 > 增效模組面板',
        placement: 'MenuBar',
        name: '增效模組面板',
    },
    {
        id: 1430,
        label: '增效模組 > 瀏覽增效模組...',
        placement: 'MenuBar',
        name: '瀏覽增效模組...',
    },
    {
        id: 1431,
        label: '增效模組 > 管理增效模組...',
        placement: 'MenuBar',
        name: '管理增效模組...',
    },
    {
        id: 1460,
        label: '選取 > 焦點區域...',
        placement: 'MenuBar',
        name: '焦點區域...',
    },
    {
        id: 1461,
        label: '選取 > 主體',
        placement: 'MenuBar',
        name: '主體',
    },
    {
        id: 1462,
        label: '選取 > 天空',
        placement: 'MenuBar',
        name: '天空',
    },
    {
        id: 1502,
        label: '檔案 > 讀入 > 裝置的影像...',
        placement: 'MenuBar',
        name: '裝置的影像...',
    },
    {
        id: 1503,
        label: '檔案 > 從 iPhone 或 iPad 讀入',
        placement: 'MenuBar',
        name: '從 iPhone 或 iPad 讀入',
    },
    {
        id: 1510,
        label: '編輯 > 內容感知填色...',
        placement: 'MenuBar',
        name: '內容感知填色...',
    },
    {
        id: 1520,
        label: '檔案 > 在 Bridge 中瀏覽...',
        placement: 'MenuBar',
        name: '在 Bridge 中瀏覽...',
    },
    {
        id: 1522,
        label: '文字 > 更多來自 Adobe Fonts 的字體...',
        placement: 'MenuBar',
        name: '更多來自 Adobe Fonts 的字體...',
    },
    {
        id: 1530,
        label: '檔案 > 關閉並跳至 Bridge...',
        placement: 'MenuBar',
        name: '關閉並跳至 Bridge...',
    },
    {
        id: 1613,
        label: '編輯 > 遠端連線...',
        placement: 'MenuBar',
        name: '遠端連線...',
    },
    {
        id: 1676,
        label: '檔案 > 指令碼 > 瀏覽...',
        placement: 'MenuBar',
        name: '瀏覽...',
    },
    {
        id: 1695,
        label: '檔案 > 轉存 > 儲存為網頁用...',
        placement: 'MenuBar',
        name: '儲存為網頁用...',
    },
    {
        id: 1696,
        label: '檔案 > 自動 > PDF 簡報...',
        placement: 'MenuBar',
        name: 'PDF 簡報...',
    },
    {
        id: 1701,
        label: '影像 > 調整 > 負片效果',
        placement: 'MenuBar',
        name: '負片效果',
    },
    {
        id: 1702,
        label: '影像 > 調整 > 均勻分配',
        placement: 'MenuBar',
        name: '均勻分配',
    },
    {
        id: 1703,
        label: '影像 > 調整 > 臨界值...',
        placement: 'MenuBar',
        name: '臨界值...',
    },
    {
        id: 1704,
        label: '影像 > 調整 > 色調分離...',
        placement: 'MenuBar',
        name: '色調分離...',
    },
    {
        id: 1750,
        label: '編輯 > 生成式填色…',
        placement: 'MenuBar',
        name: '生成式填色…',
    },
    {
        id: 1771,
        label: '編輯 > 產生影像…',
        placement: 'MenuBar',
        name: '產生影像…',
    },
    {
        id: 1776,
        label: '影像 > 生成式放大',
        placement: 'MenuBar',
        name: '生成式放大',
    },
    {
        id: 1777,
        label: '濾鏡 > AI 雜色減少…',
        placement: 'MenuBar',
        name: 'AI 雜色減少…',
    },
    {
        id: 1778,
        label: '濾鏡 > AI 銳利化…',
        placement: 'MenuBar',
        name: 'AI 銳利化…',
    },
    {
        id: 1801,
        label: '影像 > 調整 > 色階...',
        placement: 'MenuBar',
        name: '色階...',
    },
    {
        id: 1802,
        label: '影像 > 調整 > 曲線...',
        placement: 'MenuBar',
        name: '曲線...',
    },
    {
        id: 1803,
        label: '影像 > 調整 > 亮度/對比...',
        placement: 'MenuBar',
        name: '亮度/對比...',
    },
    {
        id: 1804,
        label: '影像 > 調整 > 色彩平衡...',
        placement: 'MenuBar',
        name: '色彩平衡...',
    },
    {
        id: 1805,
        label: '影像 > 調整 > 色相 / 飽和度...',
        placement: 'MenuBar',
        name: '色相 / 飽和度...',
    },
    {
        id: 1806,
        label: '影像 > 調整 > 取代顏色...',
        placement: 'MenuBar',
        name: '取代顏色...',
    },
    {
        id: 1807,
        label: '影像 > 調整 > 選取顏色...',
        placement: 'MenuBar',
        name: '選取顏色...',
    },
    {
        id: 1808,
        label: '影像 > 自動色調',
        placement: 'MenuBar',
        name: '自動色調',
    },
    {
        id: 1809,
        label: '影像 > 調整 > 去除飽和度',
        placement: 'MenuBar',
        name: '去除飽和度',
    },
    {
        id: 1810,
        label: '影像 > 自動對比',
        placement: 'MenuBar',
        name: '自動對比',
    },
    {
        id: 1817,
        label: '影像 > 自動色彩',
        placement: 'MenuBar',
        name: '自動色彩',
    },
    {
        id: 1822,
        label: '影像 > 調整 > 符合顏色...',
        placement: 'MenuBar',
        name: '符合顏色...',
    },
    {
        id: 1824,
        label: '影像 > 調整 > 黑白...',
        placement: 'MenuBar',
        name: '黑白...',
    },
    {
        id: 1827,
        label: '影像 > 調整 > 自然飽和度...',
        placement: 'MenuBar',
        name: '自然飽和度...',
    },
    {
        id: 1900,
        label: '影像 > 運算...',
        placement: 'MenuBar',
        name: '運算...',
    },
    {
        id: 1942,
        label: '圖層 > 新增 > 背景',
        placement: 'MenuBar',
        name: '背景',
    },
    {
        id: 1943,
        label: '選取 > 重新選取',
        placement: 'MenuBar',
        name: '重新選取',
    },
    {
        id: 1953,
        label: '圖層 > 向量圖遮色片 > 全部隱藏',
        placement: 'MenuBar',
        name: '全部隱藏',
    },
    {
        id: 1954,
        label: '圖層 > 向量圖遮色片 > 全部顯現',
        placement: 'MenuBar',
        name: '全部顯現',
    },
    {
        id: 1955,
        label: '圖層 > 向量圖遮色片 > 目前路徑',
        placement: 'MenuBar',
        name: '目前路徑',
    },
    {
        id: 1956,
        label: '圖層 > 向量圖遮色片 > 刪除',
        placement: 'MenuBar',
        name: '刪除',
    },
    {
        id: 1957,
        label: '圖層 > 點陣化 > 向量圖遮色片',
        placement: 'MenuBar',
        name: '向量圖遮色片',
    },
    {
        id: 1959,
        label: '圖層 > 向量圖遮色片 > 啟動(B)',
        placement: 'MenuBar',
        name: '啟動(B)',
    },
    {
        id: 1971,
        label: '選取 > 變形選取範圍',
        placement: 'MenuBar',
        name: '變形選取範圍',
    },
    {
        id: 2101,
        label: '檔案 > 列印...',
        placement: 'MenuBar',
        name: '列印...',
    },
    {
        id: 2103,
        label: '檔案 > 最近使用的檔案 > 清除最近使用的檔案清單',
        placement: 'MenuBar',
        name: '清除最近使用的檔案清單',
    },
    {
        id: 2109,
        label: '圖層 > 向量圖遮色片 > 連結',
        placement: 'MenuBar',
        name: '連結',
    },
    {
        id: 2201,
        label: '編輯 > 變形 > 縮放',
        placement: 'MenuBar',
        name: '縮放',
    },
    {
        id: 2202,
        label: '編輯 > 變形 > 傾斜',
        placement: 'MenuBar',
        name: '傾斜',
    },
    {
        id: 2203,
        label: '編輯 > 變形 > 透視',
        placement: 'MenuBar',
        name: '透視',
    },
    {
        id: 2204,
        label: '編輯 > 變形 > 扭曲',
        placement: 'MenuBar',
        name: '扭曲',
    },
    {
        id: 2205,
        label: '編輯 > 變形 > 旋轉',
        placement: 'MenuBar',
        name: '旋轉',
    },
    {
        id: 2207,
        label: '編輯 > 任意變形',
        placement: 'MenuBar',
        name: '任意變形',
    },
    {
        id: 2208,
        label: '編輯 > 變形 > 旋轉 180 度',
        placement: 'MenuBar',
        name: '旋轉 180 度',
    },
    {
        id: 2209,
        label: '編輯 > 變形 > 順時針旋轉 90 度',
        placement: 'MenuBar',
        name: '順時針旋轉 90 度',
    },
    {
        id: 2210,
        label: '編輯 > 變形 > 逆時針旋轉 90 度',
        placement: 'MenuBar',
        name: '逆時針旋轉 90 度',
    },
    {
        id: 2211,
        label: '編輯 > 變形 > 水平翻轉',
        placement: 'MenuBar',
        name: '水平翻轉',
    },
    {
        id: 2212,
        label: '編輯 > 變形 > 垂直翻轉',
        placement: 'MenuBar',
        name: '垂直翻轉',
    },
    {
        id: 2217,
        label: '編輯 > 變形 > 再一次',
        placement: 'MenuBar',
        name: '再一次',
    },
    {
        id: 2218,
        label: '文字 > 彎曲文字...',
        placement: 'MenuBar',
        name: '彎曲文字...',
    },
    {
        id: 2219,
        label: '編輯 > 變形 > 彎曲',
        placement: 'MenuBar',
        name: '彎曲',
    },
    {
        id: 2220,
        label: '編輯 > 內容感知比率',
        placement: 'MenuBar',
        name: '內容感知比率',
    },
    {
        id: 2221,
        label: '編輯 > 操控彎曲',
        placement: 'MenuBar',
        name: '操控彎曲',
    },
    {
        id: 2224,
        label: '濾鏡 > 模糊收藏館 > 光圈模糊...',
        placement: 'MenuBar',
        name: '光圈模糊...',
    },
    {
        id: 2225,
        label: '濾鏡 > 模糊收藏館 > 景色模糊...',
        placement: 'MenuBar',
        name: '景色模糊...',
    },
    {
        id: 2226,
        label: '濾鏡 > 模糊收藏館 > 移軸模糊...',
        placement: 'MenuBar',
        name: '移軸模糊...',
    },
    {
        id: 2227,
        label: '濾鏡 > 模糊收藏館 > 路徑模糊...',
        placement: 'MenuBar',
        name: '路徑模糊...',
    },
    {
        id: 2229,
        label: '濾鏡 > 模糊收藏館 > 迴轉模糊...',
        placement: 'MenuBar',
        name: '迴轉模糊...',
    },
    {
        id: 2231,
        label: '濾鏡 > 演算上色 > 火焰...',
        placement: 'MenuBar',
        name: '火焰...',
    },
    {
        id: 2232,
        label: '濾鏡 > 演算上色 > 圖片框...',
        placement: 'MenuBar',
        name: '圖片框...',
    },
    {
        id: 2233,
        label: '濾鏡 > 演算上色 > 樹...',
        placement: 'MenuBar',
        name: '樹...',
    },
    {
        id: 2250,
        label: '編輯 > 變形 > 水平分割彎曲',
        placement: 'MenuBar',
        name: '水平分割彎曲',
    },
    {
        id: 2251,
        label: '編輯 > 變形 > 垂直分割彎曲',
        placement: 'MenuBar',
        name: '垂直分割彎曲',
    },
    {
        id: 2252,
        label: '編輯 > 變形 > 交叉分割彎曲',
        placement: 'MenuBar',
        name: '交叉分割彎曲',
    },
    {
        id: 2253,
        label: '編輯 > 變形 > 移除彎曲分割',
        placement: 'MenuBar',
        name: '移除彎曲分割',
    },
    {
        id: 2254,
        label: '編輯 > 變形 > 切換參考線',
        placement: 'MenuBar',
        name: '切換參考線',
    },
    {
        id: 2255,
        label: '編輯 > 變形 > 轉換彎曲錨點',
        placement: 'MenuBar',
        name: '轉換彎曲錨點',
    },
    {
        id: 2260,
        label: '編輯 > 天空取代...',
        placement: 'MenuBar',
        name: '天空取代...',
    },
    {
        id: 2304,
        label: 'Photoshop > 偏好設定 > 效能...',
        placement: 'MenuBar',
        name: '效能...',
    },
    {
        id: 2311,
        label: 'Photoshop > 偏好設定 > 一般...',
        placement: 'MenuBar',
        name: '一般...',
    },
    {
        id: 2312,
        label: 'Photoshop > 偏好設定 > 游標...',
        placement: 'MenuBar',
        name: '游標...',
    },
    {
        id: 2313,
        label: 'Photoshop > 偏好設定 > 透明和色域...',
        placement: 'MenuBar',
        name: '透明和色域...',
    },
    {
        id: 2314,
        label: 'Photoshop > 偏好設定 > 單位和尺標...',
        placement: 'MenuBar',
        name: '單位和尺標...',
    },
    {
        id: 2315,
        label: 'Photoshop > 偏好設定 > 參考線、格點與切片...',
        placement: 'MenuBar',
        name: '參考線、格點與切片...',
    },
    {
        id: 2316,
        label: 'Photoshop > 偏好設定 > 增效模組...',
        placement: 'MenuBar',
        name: '增效模組...',
    },
    {
        id: 2317,
        label: 'Photoshop > 偏好設定 > 檔案處理...',
        placement: 'MenuBar',
        name: '檔案處理...',
    },
    {
        id: 2322,
        label: 'Photoshop > 偏好設定 > 文字...',
        placement: 'MenuBar',
        name: '文字...',
    },
    {
        id: 2323,
        label: 'Photoshop > 偏好設定 > 介面...',
        placement: 'MenuBar',
        name: '介面...',
    },
    {
        id: 2324,
        label: 'Photoshop > 偏好設定 > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > 偏好設定 > 技術預視',
        placement: 'MenuBar',
        name: '技術預視',
    },
    {
        id: 2328,
        label: 'Photoshop > 偏好設定 > 暫存磁碟...',
        placement: 'MenuBar',
        name: '暫存磁碟...',
    },
    {
        id: 2329,
        label: 'Photoshop > 偏好設定 > 記錄與 Content Credentials(H)…',
        placement: 'MenuBar',
        name: '記錄與 Content Credentials(H)…',
    },
    {
        id: 2330,
        label: 'Photoshop > 偏好設定 > 工具...',
        placement: 'MenuBar',
        name: '工具...',
    },
    {
        id: 2331,
        label: 'Photoshop > 偏好設定 > 工作區...',
        placement: 'MenuBar',
        name: '工作區...',
    },
    {
        id: 2332,
        label: 'Photoshop > 偏好設定 > 轉存...',
        placement: 'MenuBar',
        name: '轉存...',
    },
    {
        id: 2332,
        label: '檔案 > 轉存 > 轉存偏好設定...',
        placement: 'MenuBar',
        name: '轉存偏好設定...',
    },
    {
        id: 2333,
        label: 'Photoshop > 偏好設定 > 增強控制項...',
        placement: 'MenuBar',
        name: '增強控制項...',
    },
    {
        id: 2335,
        label: 'Photoshop > 偏好設定 > 處理影像…',
        placement: 'MenuBar',
        name: '處理影像…',
    },
    {
        id: 2337,
        label: 'Photoshop > 偏好設定 > 通知…',
        placement: 'MenuBar',
        name: '通知…',
    },
    {
        id: 2344,
        label: '編輯 > 顏色設定...',
        placement: 'MenuBar',
        name: '顏色設定...',
    },
    {
        id: 2345,
        label: '編輯 > OpenColorIO 設定…',
        placement: 'MenuBar',
        name: 'OpenColorIO 設定…',
    },
    {
        id: 2361,
        label: '編輯 > 清除記憶 > 步驟記錄',
        placement: 'MenuBar',
        name: '步驟記錄',
    },
    {
        id: 2701,
        label: '圖層 > 修邊 > 移除黑色邊緣調合',
        placement: 'MenuBar',
        name: '移除黑色邊緣調合',
    },
    {
        id: 2703,
        label: '圖層 > 修邊 > 移除白色邊緣調合',
        placement: 'MenuBar',
        name: '移除白色邊緣調合',
    },
    {
        id: 2711,
        label: '圖層 > 排列順序 > 移至最前',
        placement: 'MenuBar',
        name: '移至最前',
    },
    {
        id: 2712,
        label: '圖層 > 排列順序 > 前移',
        placement: 'MenuBar',
        name: '前移',
    },
    {
        id: 2713,
        label: '圖層 > 排列順序 > 後移',
        placement: 'MenuBar',
        name: '後移',
    },
    {
        id: 2714,
        label: '圖層 > 排列順序 > 移至最後',
        placement: 'MenuBar',
        name: '移至最後',
    },
    {
        id: 2715,
        label: '圖層 > 排列順序 > 反轉',
        placement: 'MenuBar',
        name: '反轉',
    },
    {
        id: 2769,
        label: '圖層 > 智慧型濾鏡 > 關閉智慧型濾鏡',
        placement: 'MenuBar',
        name: '關閉智慧型濾鏡',
    },
    {
        id: 2770,
        label: '圖層 > 智慧型濾鏡 > 清除智慧型濾鏡',
        placement: 'MenuBar',
        name: '清除智慧型濾鏡',
    },
    {
        id: 2802,
        label: '檢視 > 校樣設定 > 自訂...',
        placement: 'MenuBar',
        name: '自訂...',
    },
    {
        id: 2803,
        label: '檢視 > 校樣設定 > 使用中的 CMYK',
        placement: 'MenuBar',
        name: '使用中的 CMYK',
    },
    {
        id: 2804,
        label: '檢視 > 校樣設定 > 使用中的青色印版',
        placement: 'MenuBar',
        name: '使用中的青色印版',
    },
    {
        id: 2805,
        label: '檢視 > 校樣設定 > 使用中的洋紅色印版',
        placement: 'MenuBar',
        name: '使用中的洋紅色印版',
    },
    {
        id: 2806,
        label: '檢視 > 校樣設定 > 使用中的黃色印版',
        placement: 'MenuBar',
        name: '使用中的黃色印版',
    },
    {
        id: 2807,
        label: '檢視 > 校樣設定 > 使用中的黑色印版',
        placement: 'MenuBar',
        name: '使用中的黑色印版',
    },
    {
        id: 2808,
        label: '檢視 > 校樣設定 > 使用中的 CMY 印版',
        placement: 'MenuBar',
        name: '使用中的 CMY 印版',
    },
    {
        id: 2809,
        label: '檢視 > 校樣設定 > 舊版 Macintosh RGB (Gamma 1.8)',
        placement: 'MenuBar',
        name: '舊版 Macintosh RGB (Gamma 1.8)',
    },
    {
        id: 2810,
        label: '檢視 > 校樣設定 > 網際網路標準 RGB (sRGB)',
        placement: 'MenuBar',
        name: '網際網路標準 RGB (sRGB)',
    },
    {
        id: 2811,
        label: '檢視 > 校樣設定 > 螢幕 RGB',
        placement: 'MenuBar',
        name: '螢幕 RGB',
    },
    {
        id: 2815,
        label: '檢視 > 校樣設定 > 色盲 - 紅色盲類型',
        placement: 'MenuBar',
        name: '色盲 - 紅色盲類型',
    },
    {
        id: 2816,
        label: '檢視 > 校樣設定 > 色盲 - 綠色盲類型',
        placement: 'MenuBar',
        name: '色盲 - 綠色盲類型',
    },
    {
        id: 2820,
        label: '影像 > 分析 > 尺標工具',
        placement: 'MenuBar',
        name: '尺標工具',
    },
    {
        id: 2830,
        label: '影像 > 分析 > 置入比率標記...',
        placement: 'MenuBar',
        name: '置入比率標記...',
    },
    {
        id: 2841,
        label: '影像 > 分析 > 設定度量比率 > 預設(D)',
        placement: 'MenuBar',
        name: '預設(D)',
    },
    {
        id: 2842,
        label: '影像 > 分析 > 設定度量比率 > 自訂(C)...',
        placement: 'MenuBar',
        name: '自訂(C)...',
    },
    {
        id: 2851,
        label: '影像 > 分析 > 選取資料點 > 自訂(C)...',
        placement: 'MenuBar',
        name: '自訂(C)...',
    },
    {
        id: 2860,
        label: '影像 > 分析 > 記錄度量',
        placement: 'MenuBar',
        name: '記錄度量',
    },
    {
        id: 2880,
        label: '視窗 > 度量記錄',
        placement: 'MenuBar',
        name: '度量記錄',
    },
    {
        id: 2912,
        label: '編輯 > 清除記憶 > 剪貼簿',
        placement: 'MenuBar',
        name: '剪貼簿',
    },
    {
        id: 2915,
        label: '編輯 > 清除記憶 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 2920,
        label: '編輯 > 清除記憶 > 視訊快取',
        placement: 'MenuBar',
        name: '視訊快取',
    },
    {
        id: 2939,
        label: '視窗 > 工作區 > 鎖定工作區(L)',
        placement: 'MenuBar',
        name: '鎖定工作區(L)',
    },
    {
        id: 2940,
        label: '檢視 > 參考線 > 鎖定參考線',
        placement: 'MenuBar',
        name: '鎖定參考線',
    },
    {
        id: 2950,
        label: '檢視 > 參考線 > 清除參考線',
        placement: 'MenuBar',
        name: '清除參考線',
    },
    {
        id: 2951,
        label: '圖層 > 刪除 > 隱藏圖層',
        placement: 'MenuBar',
        name: '隱藏圖層',
    },
    {
        id: 2952,
        label: '檢視 > 參考線 > 清除選取的工作區域參考線',
        placement: 'MenuBar',
        name: '清除選取的工作區域參考線',
    },
    {
        id: 2953,
        label: '檢視 > 參考線 > 清除畫布參考線',
        placement: 'MenuBar',
        name: '清除畫布參考線',
    },
    {
        id: 2956,
        label: '圖層 > 新增 > 從圖層建立群組...',
        placement: 'MenuBar',
        name: '從圖層建立群組...',
    },
    {
        id: 2957,
        label: '圖層 > 鎖定圖層...',
        placement: 'MenuBar',
        name: '鎖定圖層...',
    },
    {
        id: 2958,
        label: '圖層 > 群組圖層',
        placement: 'MenuBar',
        name: '群組圖層',
    },
    {
        id: 2959,
        label: '圖層 > 解散圖層群組',
        placement: 'MenuBar',
        name: '解散圖層群組',
    },
    {
        id: 2960,
        label: '圖層 > 選取連結的圖層',
        placement: 'MenuBar',
        name: '選取連結的圖層',
    },
    {
        id: 2961,
        label: '圖層 > 連結圖層',
        placement: 'MenuBar',
        name: '連結圖層',
    },
    {
        id: 2962,
        label: '選取 > 全部圖層',
        placement: 'MenuBar',
        name: '全部圖層',
    },
    {
        id: 2963,
        label: '選取 > 取消選取圖層',
        placement: 'MenuBar',
        name: '取消選取圖層',
    },
    {
        id: 2967,
        label: '檢視 > 鎖定切片',
        placement: 'MenuBar',
        name: '鎖定切片',
    },
    {
        id: 2969,
        label: '檢視 > 清除切片',
        placement: 'MenuBar',
        name: '清除切片',
    },
    {
        id: 2970,
        label: '圖層 > 新增 > 拷貝的圖層',
        placement: 'MenuBar',
        name: '拷貝的圖層',
    },
    {
        id: 2971,
        label: '圖層 > 新增 > 剪下的圖層',
        placement: 'MenuBar',
        name: '剪下的圖層',
    },
    {
        id: 2972,
        label: '圖層 > 建立剪裁遮色片',
        placement: 'MenuBar',
        name: '建立剪裁遮色片',
    },
    {
        id: 2976,
        label: '圖層 > 新增 > 群組...',
        placement: 'MenuBar',
        name: '群組...',
    },
    {
        id: 2980,
        label: '圖層 > 智慧型物件 > 轉換為智慧型物件',
        placement: 'MenuBar',
        name: '轉換為智慧型物件',
    },
    {
        id: 2981,
        label: '圖層 > 智慧型物件 > 透過拷貝新增智慧型物件',
        placement: 'MenuBar',
        name: '透過拷貝新增智慧型物件',
    },
    {
        id: 2982,
        label: '選取 > 尋找圖層',
        placement: 'MenuBar',
        name: '尋找圖層',
    },
    {
        id: 2983,
        label: '圖層 > 重新命名圖層...',
        placement: 'MenuBar',
        name: '重新命名圖層...',
    },
    {
        id: 2986,
        label: '選取 > 隔離圖層',
        placement: 'MenuBar',
        name: '隔離圖層',
    },
    {
        id: 2991,
        label: '影像 > 影像旋轉 > 90 度順時針',
        placement: 'MenuBar',
        name: '90 度順時針',
    },
    {
        id: 2992,
        label: '影像 > 影像旋轉 > 90 度逆時針',
        placement: 'MenuBar',
        name: '90 度逆時針',
    },
    {
        id: 2993,
        label: '影像 > 影像旋轉 > 180 度',
        placement: 'MenuBar',
        name: '180 度',
    },
    {
        id: 2994,
        label: '影像 > 影像旋轉 > 任意...',
        placement: 'MenuBar',
        name: '任意...',
    },
    {
        id: 2996,
        label: '影像 > 影像旋轉 > 水平翻轉版面',
        placement: 'MenuBar',
        name: '水平翻轉版面',
    },
    {
        id: 2997,
        label: '影像 > 影像旋轉 > 垂直翻轉版面',
        placement: 'MenuBar',
        name: '垂直翻轉版面',
    },
    {
        id: 3056,
        label: '影像 > 調整 > 色版混合器...',
        placement: 'MenuBar',
        name: '色版混合器...',
    },
    {
        id: 3062,
        label: '影像 > 調整 > 漸層對應...',
        placement: 'MenuBar',
        name: '漸層對應...',
    },
    {
        id: 3063,
        label: '影像 > 調整 > 相片濾鏡…',
        placement: 'MenuBar',
        name: '相片濾鏡…',
    },
    {
        id: 3065,
        label: '影像 > 調整 > 陰影/亮部...',
        placement: 'MenuBar',
        name: '陰影/亮部...',
    },
    {
        id: 3066,
        label: '影像 > 調整 > 顏色查詢...',
        placement: 'MenuBar',
        name: '顏色查詢...',
    },
    {
        id: 3067,
        label: '影像 > 調整 > 曝光度...',
        placement: 'MenuBar',
        name: '曝光度...',
    },
    {
        id: 3076,
        label: '圖層 > 智慧型濾鏡 > 關閉濾鏡遮色片',
        placement: 'MenuBar',
        name: '關閉濾鏡遮色片',
    },
    {
        id: 3083,
        label: '圖層 > 新增調整圖層 > 曝光度...',
        placement: 'MenuBar',
        name: '曝光度...',
    },
    {
        id: 3085,
        label: '圖層 > 新增調整圖層 > 顏色和飽和度…',
        placement: 'MenuBar',
        name: '顏色和飽和度…',
    },
    {
        id: 3090,
        label: '檔案 > 置入連結的智慧型物件...',
        placement: 'MenuBar',
        name: '置入連結的智慧型物件...',
    },
    {
        id: 3091,
        label: '圖層 > 智慧型物件 > 顯現在 Finder 中',
        placement: 'MenuBar',
        name: '顯現在 Finder 中',
    },
    {
        id: 3092,
        label: '檔案 > 封裝...',
        placement: 'MenuBar',
        name: '封裝...',
    },
    {
        id: 3098,
        label: '檔案 > 自動 > 產生器外掛程式',
        placement: 'MenuBar',
        name: '產生器外掛程式',
    },
    {
        id: 3187,
        label: '視窗 > 樣式',
        placement: 'MenuBar',
        name: '樣式',
    },
    {
        id: 3300,
        label: '文字 > 面板 > 字元面板',
        placement: 'MenuBar',
        name: '字元面板',
    },
    {
        id: 3300,
        label: '視窗 > 字元',
        placement: 'MenuBar',
        name: '字元',
    },
    {
        id: 3309,
        label: '文字 > OpenType > 標準連字',
        placement: 'MenuBar',
        name: '標準連字',
    },
    {
        id: 3310,
        label: '文字 > OpenType > 舊樣式',
        placement: 'MenuBar',
        name: '舊樣式',
    },
    {
        id: 3327,
        label: '文字 > OpenType > 等比公制字',
        placement: 'MenuBar',
        name: '等比公制字',
    },
    {
        id: 3334,
        label: '文字 > OpenType > 花飾字',
        placement: 'MenuBar',
        name: '花飾字',
    },
    {
        id: 3338,
        label: '文字 > OpenType > 上下文替代字',
        placement: 'MenuBar',
        name: '上下文替代字',
    },
    {
        id: 3339,
        label: '文字 > OpenType > 自由決定連字',
        placement: 'MenuBar',
        name: '自由決定連字',
    },
    {
        id: 3340,
        label: '文字 > OpenType > 文體替代字',
        placement: 'MenuBar',
        name: '文體替代字',
    },
    {
        id: 3341,
        label: '文字 > OpenType > 標題替代字',
        placement: 'MenuBar',
        name: '標題替代字',
    },
    {
        id: 3342,
        label: '文字 > OpenType > 裝飾字',
        placement: 'MenuBar',
        name: '裝飾字',
    },
    {
        id: 3343,
        label: '文字 > OpenType > 序數字',
        placement: 'MenuBar',
        name: '序數字',
    },
    {
        id: 3344,
        label: '文字 > OpenType > 分數字',
        placement: 'MenuBar',
        name: '分數字',
    },
    {
        id: 3345,
        label: '文字 > OpenType > 日文 JIS78',
        placement: 'MenuBar',
        name: '日文 JIS78',
    },
    {
        id: 3346,
        label: '文字 > OpenType > 日文專業',
        placement: 'MenuBar',
        name: '日文專業',
    },
    {
        id: 3347,
        label: '文字 > OpenType > 日文傳統',
        placement: 'MenuBar',
        name: '日文傳統',
    },
    {
        id: 3348,
        label: '文字 > OpenType > 假名',
        placement: 'MenuBar',
        name: '假名',
    },
    {
        id: 3349,
        label: '文字 > OpenType > 羅馬斜體字',
        placement: 'MenuBar',
        name: '羅馬斜體字',
    },
    {
        id: 3350,
        label: '文字 > 面板 > 段落面板',
        placement: 'MenuBar',
        name: '段落面板',
    },
    {
        id: 3350,
        label: '視窗 > 段落',
        placement: 'MenuBar',
        name: '段落',
    },
    {
        id: 3370,
        label: '文字 > 消除鋸齒 > 無',
        placement: 'MenuBar',
        name: '無',
    },
    {
        id: 3371,
        label: '文字 > 消除鋸齒 > 尖銳',
        placement: 'MenuBar',
        name: '尖銳',
    },
    {
        id: 3372,
        label: '文字 > 消除鋸齒 > 強烈',
        placement: 'MenuBar',
        name: '強烈',
    },
    {
        id: 3373,
        label: '文字 > 消除鋸齒 > 平滑',
        placement: 'MenuBar',
        name: '平滑',
    },
    {
        id: 3374,
        label: '文字 > 消除鋸齒 > 銳利',
        placement: 'MenuBar',
        name: '銳利',
    },
    {
        id: 3375,
        label: '文字 > 消除鋸齒 > Mac LCD',
        placement: 'MenuBar',
        name: 'Mac LCD',
    },
    {
        id: 3376,
        label: '文字 > 消除鋸齒 > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: '文字 > 轉換文字形狀類型',
        placement: 'MenuBar',
        name: '轉換文字形狀類型',
    },
    {
        id: 3390,
        label: '文字 > 更新全部文字圖層',
        placement: 'MenuBar',
        name: '更新全部文字圖層',
    },
    {
        id: 3392,
        label: '編輯 > 檢查拼字...',
        placement: 'MenuBar',
        name: '檢查拼字...',
    },
    {
        id: 3393,
        label: '編輯 > 尋找與取代文字...',
        placement: 'MenuBar',
        name: '尋找與取代文字...',
    },
    {
        id: 3409,
        label: '圖層 > 組合形狀 > 統一形狀',
        placement: 'MenuBar',
        name: '統一形狀',
    },
    {
        id: 3410,
        label: '圖層 > 組合形狀 > 去除最前形状',
        placement: 'MenuBar',
        name: '去除最前形状',
    },
    {
        id: 3411,
        label: '圖層 > 組合形狀 > 統一重疊處形狀',
        placement: 'MenuBar',
        name: '統一重疊處形狀',
    },
    {
        id: 3412,
        label: '圖層 > 組合形狀 > 去除重疊處形狀',
        placement: 'MenuBar',
        name: '去除重疊處形狀',
    },
    {
        id: 3438,
        label: '圖層 > 拷貝 SVG',
        placement: 'MenuBar',
        name: '拷貝 SVG',
    },
    {
        id: 3439,
        label: '圖層 > 拷貝 CSS',
        placement: 'MenuBar',
        name: '拷貝 CSS',
    },
    {
        id: 3443,
        label: '檔案 > 轉存 > 轉存為...',
        placement: 'MenuBar',
        name: '轉存為...',
    },
    {
        id: 3444,
        label: '檔案 > 轉存 > 快速轉存為 PNG',
        placement: 'MenuBar',
        name: '快速轉存為 PNG',
    },
    {
        id: 3446,
        label: '圖層 > 快速轉存為 PNG',
        placement: 'MenuBar',
        name: '快速轉存為 PNG',
    },
    {
        id: 3447,
        label: '圖層 > 轉存為...',
        placement: 'MenuBar',
        name: '轉存為...',
    },
    {
        id: 3451,
        label: '文字 > 語言選項 > 左到右阿拉伯數字 - 123%',
        placement: 'MenuBar',
        name: '左到右阿拉伯數字 - 123%',
    },
    {
        id: 3452,
        label: '文字 > 語言選項 > 波斯數字',
        placement: 'MenuBar',
        name: '波斯數字',
    },
    {
        id: 3453,
        label: '文字 > 語言選項 > 印度數字',
        placement: 'MenuBar',
        name: '印度數字',
    },
    {
        id: 3459,
        label: '文字 > 語言選項 > 右到左阿拉伯數字 - %123',
        placement: 'MenuBar',
        name: '右到左阿拉伯數字 - %123',
    },
    {
        id: 3500,
        label: '檢視 > 輔助項目',
        placement: 'MenuBar',
        name: '輔助項目',
    },
    {
        id: 3501,
        label: '檢視 > 顯示 > 選取範圍邊緣(S)',
        placement: 'MenuBar',
        name: '選取範圍邊緣(S)',
    },
    {
        id: 3502,
        label: '檢視 > 顯示 > 目標路徑(P)',
        placement: 'MenuBar',
        name: '目標路徑(P)',
    },
    {
        id: 3503,
        label: '檢視 > 顯示 > 參考線',
        placement: 'MenuBar',
        name: '參考線',
    },
    {
        id: 3504,
        label: '檢視 > 顯示 > 格點(G)',
        placement: 'MenuBar',
        name: '格點(G)',
    },
    {
        id: 3505,
        label: '檢視 > 顯示 > 切片(L)',
        placement: 'MenuBar',
        name: '切片(L)',
    },
    {
        id: 3506,
        label: '檢視 > 顯示 > 備註(O)',
        placement: 'MenuBar',
        name: '備註(O)',
    },
    {
        id: 3507,
        label: '檢視 > 顯示 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 3508,
        label: '檢視 > 顯示 > 無',
        placement: 'MenuBar',
        name: '無',
    },
    {
        id: 3510,
        label: '檢視 > 顯示 > 顯示輔助項目選項...',
        placement: 'MenuBar',
        name: '顯示輔助項目選項...',
    },
    {
        id: 3511,
        label: '檢視 > 顯示 > 智慧型參考線(M)',
        placement: 'MenuBar',
        name: '智慧型參考線(M)',
    },
    {
        id: 3512,
        label: '檢視 > 顯示 > 圖層邊緣(E)',
        placement: 'MenuBar',
        name: '圖層邊緣(E)',
    },
    {
        id: 3513,
        label: '檢視 > 顯示 > 計算(C)',
        placement: 'MenuBar',
        name: '計算(C)',
    },
    {
        id: 3514,
        label: '檢視 > 顯示 > 像素格點(X)',
        placement: 'MenuBar',
        name: '像素格點(X)',
    },
    {
        id: 3517,
        label: '檢視 > 顯示 > 網紋(H)',
        placement: 'MenuBar',
        name: '網紋(H)',
    },
    {
        id: 3520,
        label: '檢視 > 靠齊',
        placement: 'MenuBar',
        name: '靠齊',
    },
    {
        id: 3521,
        label: '檢視 > 靠齊至 > 參考線',
        placement: 'MenuBar',
        name: '參考線',
    },
    {
        id: 3522,
        label: '檢視 > 靠齊至 > 格點',
        placement: 'MenuBar',
        name: '格點',
    },
    {
        id: 3523,
        label: '檢視 > 靠齊至 > 切片',
        placement: 'MenuBar',
        name: '切片',
    },
    {
        id: 3524,
        label: '檢視 > 靠齊至 > 文件邊界',
        placement: 'MenuBar',
        name: '文件邊界',
    },
    {
        id: 3527,
        label: '檢視 > 靠齊至 > 全部',
        placement: 'MenuBar',
        name: '全部',
    },
    {
        id: 3528,
        label: '檢視 > 靠齊至 > 無',
        placement: 'MenuBar',
        name: '無',
    },
    {
        id: 3530,
        label: '檢視 > 靠齊至 > 圖層',
        placement: 'MenuBar',
        name: '圖層',
    },
    {
        id: 3532,
        label: '檢視 > 顯示 > 圖樣預視拼貼邊界',
        placement: 'MenuBar',
        name: '圖樣預視拼貼邊界',
    },
    {
        id: 3533,
        label: '檢視 > 顯示 > 工作區域參考線',
        placement: 'MenuBar',
        name: '工作區域參考線',
    },
    {
        id: 3535,
        label: '檢視 > 顯示 > 工作區域名稱',
        placement: 'MenuBar',
        name: '工作區域名稱',
    },
    {
        id: 3536,
        label: '檢視 > 顯示 > 畫布參考線',
        placement: 'MenuBar',
        name: '畫布參考線',
    },
    {
        id: 3541,
        label: '圖層 > 點陣化 > 形狀',
        placement: 'MenuBar',
        name: '形狀',
    },
    {
        id: 3542,
        label: '圖層 > 點陣化 > 文字',
        placement: 'MenuBar',
        name: '文字',
    },
    {
        id: 3542,
        label: '文字 > 點陣化文字圖層',
        placement: 'MenuBar',
        name: '點陣化文字圖層',
    },
    {
        id: 3544,
        label: '圖層 > 點陣化 > 填滿內容',
        placement: 'MenuBar',
        name: '填滿內容',
    },
    {
        id: 3545,
        label: '圖層 > 點陣化 > 全部圖層',
        placement: 'MenuBar',
        name: '全部圖層',
    },
    {
        id: 3547,
        label: '圖層 > 點陣化 > 圖層',
        placement: 'MenuBar',
        name: '圖層',
    },
    {
        id: 3549,
        label: '圖層 > 智慧型物件 > 點陣化',
        placement: 'MenuBar',
        name: '點陣化',
    },
    {
        id: 3549,
        label: '圖層 > 點陣化 > 智慧型物件',
        placement: 'MenuBar',
        name: '智慧型物件',
    },
    {
        id: 3551,
        label: '圖層 > 點陣化 > 視訊',
        placement: 'MenuBar',
        name: '視訊',
    },
    {
        id: 3553,
        label: '圖層 > 點陣化 > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: '圖層 > 視訊圖層 > 點陣化',
        placement: 'MenuBar',
        name: '點陣化',
    },
    {
        id: 3557,
        label: '圖層 > 點陣化 > 圖層樣式',
        placement: 'MenuBar',
        name: '圖層樣式',
    },
    {
        id: 3561,
        label: '圖層 > 點陣化 > 生成式',
        placement: 'MenuBar',
        name: '生成式',
    },
    {
        id: 3585,
        label: '檢視 > 顯示 > 編輯圖釘',
        placement: 'MenuBar',
        name: '編輯圖釘',
    },
    {
        id: 3911,
        label: '濾鏡 > 新一代濾鏡 > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: '說明 > 更新...',
        placement: 'MenuBar',
        name: '更新...',
    },
    {
        id: 4210,
        label: '視窗 > 工具預設集',
        placement: 'MenuBar',
        name: '工具預設集',
    },
    {
        id: 5059,
        label: '圖層 > 圖層遮色片 > 刪除',
        placement: 'MenuBar',
        name: '刪除',
    },
    {
        id: 5068,
        label: '編輯 > 選擇性貼上 > 貼至範圍外',
        placement: 'MenuBar',
        name: '貼至範圍外',
    },
    {
        id: 5069,
        label: '選取 > 以快速遮色片模式編輯',
        placement: 'MenuBar',
        name: '以快速遮色片模式編輯',
    },
    {
        id: 5085,
        label: '圖層 > 圖層遮色片 > 連結',
        placement: 'MenuBar',
        name: '連結',
    },
    {
        id: 5095,
        label: '圖層 > 圖層遮色片 > 套用',
        placement: 'MenuBar',
        name: '套用',
    },
    {
        id: 5115,
        label: '視窗 > 工作區 > 新增工作區(N)...',
        placement: 'MenuBar',
        name: '新增工作區(N)...',
    },
    {
        id: 5116,
        label: '視窗 > 工作區 > 刪除工作區(D)...',
        placement: 'MenuBar',
        name: '刪除工作區(D)...',
    },
    {
        id: 5117,
        label: '視窗 > 工作區 > 重設基本功能(R)',
        placement: 'MenuBar',
        name: '重設基本功能(R)',
    },
    {
        id: 5217,
        label: '圖層 > 新增基於圖層的切片',
        placement: 'MenuBar',
        name: '新增基於圖層的切片',
    },
    {
        id: 5226,
        label: '圖層 > 智慧型濾鏡 > 刪除濾鏡遮色片',
        placement: 'MenuBar',
        name: '刪除濾鏡遮色片',
    },
    {
        id: 5613,
        label: '檢視 > 參考線 > 新增參考線...',
        placement: 'MenuBar',
        name: '新增參考線...',
    },
    {
        id: 5614,
        label: '檢視 > 參考線 > 新增參考線配置...',
        placement: 'MenuBar',
        name: '新增參考線配置...',
    },
    {
        id: 5615,
        label: '檢視 > 參考線 > 從形狀新增參考線',
        placement: 'MenuBar',
        name: '從形狀新增參考線',
    },
    {
        id: 5624,
        label: '編輯 > 定義自訂形狀...',
        placement: 'MenuBar',
        name: '定義自訂形狀...',
    },
    {
        id: 5634,
        label: '視窗 > 工作區 > 基本功能 (預設)(E)',
        placement: 'MenuBar',
        name: '基本功能 (預設)(E)',
    },
    {
        id: 5929,
        label: '視窗 > 排列順序 > 全部移至最前',
        placement: 'MenuBar',
        name: '全部移至最前',
    },
    {
        id: 5930,
        label: '視窗 > 排列順序 > 重疊顯示',
        placement: 'MenuBar',
        name: '重疊顯示',
    },
    {
        id: 5931,
        label: '視窗 > 排列順序 > 並排顯示',
        placement: 'MenuBar',
        name: '並排顯示',
    },
    {
        id: 5932,
        label: '視窗 > 排列順序 > 最小化',
        placement: 'MenuBar',
        name: '最小化',
    },
    {
        id: 5933,
        label: '視窗 > 排列順序 > 全部垂直拼貼',
        placement: 'MenuBar',
        name: '全部垂直拼貼',
    },
    {
        id: 5934,
        label: '視窗 > 排列順序 > 全部水平拼貼',
        placement: 'MenuBar',
        name: '全部水平拼貼',
    },
    {
        id: 5935,
        label: '視窗 > 排列順序 > 2 欄式水平',
        placement: 'MenuBar',
        name: '2 欄式水平',
    },
    {
        id: 5936,
        label: '視窗 > 排列順序 > 2 欄式垂直',
        placement: 'MenuBar',
        name: '2 欄式垂直',
    },
    {
        id: 5937,
        label: '視窗 > 排列順序 > 3 欄式水平',
        placement: 'MenuBar',
        name: '3 欄式水平',
    },
    {
        id: 5938,
        label: '視窗 > 排列順序 > 3 欄式垂直',
        placement: 'MenuBar',
        name: '3 欄式垂直',
    },
    {
        id: 5939,
        label: '視窗 > 排列順序 > 3 欄式堆疊',
        placement: 'MenuBar',
        name: '3 欄式堆疊',
    },
    {
        id: 5940,
        label: '視窗 > 排列順序 > 4 欄式',
        placement: 'MenuBar',
        name: '4 欄式',
    },
    {
        id: 5941,
        label: '視窗 > 排列順序 > 6 欄式',
        placement: 'MenuBar',
        name: '6 欄式',
    },
    {
        id: 5956,
        label: '說明 > Photoshop 說明...',
        placement: 'MenuBar',
        name: 'Photoshop 說明...',
    },
    {
        id: 5957,
        label: '編輯 > 搜尋',
        placement: 'MenuBar',
        name: '搜尋',
    },
    {
        id: 5960,
        label: '視窗 > 排列順序 > 符合縮放顯示',
        placement: 'MenuBar',
        name: '符合縮放顯示',
    },
    {
        id: 5962,
        label: '視窗 > 排列順序 > 符合位置',
        placement: 'MenuBar',
        name: '符合位置',
    },
    {
        id: 5963,
        label: '視窗 > 排列順序 > 符合旋轉',
        placement: 'MenuBar',
        name: '符合旋轉',
    },
    {
        id: 5964,
        label: '視窗 > 排列順序 > 全部符合',
        placement: 'MenuBar',
        name: '全部符合',
    },
    {
        id: 5966,
        label: '檔案 > 共用以供審閱',
        placement: 'MenuBar',
        name: '共用以供審閱',
    },
    {
        id: 5967,
        label: '檔案 > 邀請參與編輯…',
        placement: 'MenuBar',
        name: '邀請參與編輯…',
    },
    {
        id: 5968,
        label: '檔案 > 轉存 > 傳送至 Firefly 展示板',
        placement: 'MenuBar',
        name: '傳送至 Firefly 展示板',
    },
    {
        id: 5980,
        label: '編輯 > 鍵盤快速鍵...',
        placement: 'MenuBar',
        name: '鍵盤快速鍵...',
    },
    {
        id: 5981,
        label: '視窗 > 工作區 > 鍵盤快速鍵和選單(K)...',
        placement: 'MenuBar',
        name: '鍵盤快速鍵和選單(K)...',
    },
    {
        id: 5982,
        label: '編輯 > 選單...',
        placement: 'MenuBar',
        name: '選單...',
    },
    {
        id: 5983,
        label: '編輯 > 工具列...',
        placement: 'MenuBar',
        name: '工具列...',
    },
    {
        id: 5991,
        label: '檢視 > 螢幕模式 > 標準螢幕模式',
        placement: 'MenuBar',
        name: '標準螢幕模式',
    },
    {
        id: 5992,
        label: '檢視 > 螢幕模式 > 具選單列的全螢幕模式',
        placement: 'MenuBar',
        name: '具選單列的全螢幕模式',
    },
    {
        id: 5993,
        label: '檢視 > 螢幕模式 > 全螢幕模式',
        placement: 'MenuBar',
        name: '全螢幕模式',
    },
    {
        id: 5996,
        label: '視窗 > 排列順序 > 在視窗中浮動',
        placement: 'MenuBar',
        name: '在視窗中浮動',
    },
    {
        id: 5997,
        label: '視窗 > 排列順序 > 全部浮動至視窗',
        placement: 'MenuBar',
        name: '全部浮動至視窗',
    },
    {
        id: 5998,
        label: '視窗 > 排列順序 > 全部合併至標籤',
        placement: 'MenuBar',
        name: '全部合併至標籤',
    },
    {
        id: 6300,
        label: '圖層 > 新增填滿圖層 > 純色...',
        placement: 'MenuBar',
        name: '純色...',
    },
    {
        id: 6301,
        label: '圖層 > 新增填滿圖層 > 漸層...',
        placement: 'MenuBar',
        name: '漸層...',
    },
    {
        id: 6302,
        label: '圖層 > 新增填滿圖層 > 圖樣...',
        placement: 'MenuBar',
        name: '圖樣...',
    },
    {
        id: 6303,
        label: '圖層 > 新增調整圖層 > 色階...',
        placement: 'MenuBar',
        name: '色階...',
    },
    {
        id: 6304,
        label: '圖層 > 新增調整圖層 > 曲線...',
        placement: 'MenuBar',
        name: '曲線...',
    },
    {
        id: 6305,
        label: '圖層 > 新增調整圖層 > 色彩平衡...',
        placement: 'MenuBar',
        name: '色彩平衡...',
    },
    {
        id: 6306,
        label: '圖層 > 新增調整圖層 > 亮度/對比...',
        placement: 'MenuBar',
        name: '亮度/對比...',
    },
    {
        id: 6308,
        label: '圖層 > 新增調整圖層 > 色相/飽和度...',
        placement: 'MenuBar',
        name: '色相/飽和度...',
    },
    {
        id: 6309,
        label: '圖層 > 新增調整圖層 > 選取顏色...',
        placement: 'MenuBar',
        name: '選取顏色...',
    },
    {
        id: 6310,
        label: '圖層 > 新增調整圖層 > 色版混合器...',
        placement: 'MenuBar',
        name: '色版混合器...',
    },
    {
        id: 6311,
        label: '圖層 > 新增調整圖層 > 漸層對應...',
        placement: 'MenuBar',
        name: '漸層對應...',
    },
    {
        id: 6312,
        label: '圖層 > 新增調整圖層 > 相片濾鏡...',
        placement: 'MenuBar',
        name: '相片濾鏡...',
    },
    {
        id: 6313,
        label: '圖層 > 新增調整圖層 > 負片效果...',
        placement: 'MenuBar',
        name: '負片效果...',
    },
    {
        id: 6314,
        label: '圖層 > 新增調整圖層 > 臨界值...',
        placement: 'MenuBar',
        name: '臨界值...',
    },
    {
        id: 6315,
        label: '圖層 > 新增調整圖層 > 色調分離...',
        placement: 'MenuBar',
        name: '色調分離...',
    },
    {
        id: 6332,
        label: '圖層 > 智慧型物件 > 編輯內容',
        placement: 'MenuBar',
        name: '編輯內容',
    },
    {
        id: 6333,
        label: '圖層 > 智慧型物件 > 取代內容...',
        placement: 'MenuBar',
        name: '取代內容...',
    },
    {
        id: 6334,
        label: '圖層 > 智慧型物件 > 轉存內容...',
        placement: 'MenuBar',
        name: '轉存內容...',
    },
    {
        id: 6337,
        label: '圖層 > 新增調整圖層 > 顏色查詢...',
        placement: 'MenuBar',
        name: '顏色查詢...',
    },
    {
        id: 6339,
        label: '圖層 > 智慧型物件 > 轉換為連結物件...',
        placement: 'MenuBar',
        name: '轉換為連結物件...',
    },
    {
        id: 6340,
        label: '圖層 > 智慧型物件 > 重新連結至檔案...',
        placement: 'MenuBar',
        name: '重新連結至檔案...',
    },
    {
        id: 6341,
        label: '圖層 > 智慧型物件 > 重新連結至資料庫圖形...',
        placement: 'MenuBar',
        name: '重新連結至資料庫圖形...',
    },
    {
        id: 6342,
        label: '圖層 > 智慧型物件 > 更新修改過的內容',
        placement: 'MenuBar',
        name: '更新修改過的內容',
    },
    {
        id: 6343,
        label: '圖層 > 智慧型物件 > 更新所有修改過的內容',
        placement: 'MenuBar',
        name: '更新所有修改過的內容',
    },
    {
        id: 6345,
        label: '圖層 > 智慧型物件 > 嵌入連結物件',
        placement: 'MenuBar',
        name: '嵌入連結物件',
    },
    {
        id: 6346,
        label: '圖層 > 智慧型物件 > 嵌入所有連結物件',
        placement: 'MenuBar',
        name: '嵌入所有連結物件',
    },
    {
        id: 6347,
        label: '圖層 > 智慧型物件 > 重設變形',
        placement: 'MenuBar',
        name: '重設變形',
    },
    {
        id: 6348,
        label: '圖層 > 新增調整圖層 > 黑白...',
        placement: 'MenuBar',
        name: '黑白...',
    },
    {
        id: 6351,
        label: '圖層 > 視訊圖層 > 從檔案新增視訊圖層...',
        placement: 'MenuBar',
        name: '從檔案新增視訊圖層...',
    },
    {
        id: 6352,
        label: '圖層 > 視訊圖層 > 新增空白視訊圖層',
        placement: 'MenuBar',
        name: '新增空白視訊圖層',
    },
    {
        id: 6353,
        label: '圖層 > 視訊圖層 > 插入空白影格',
        placement: 'MenuBar',
        name: '插入空白影格',
    },
    {
        id: 6354,
        label: '圖層 > 視訊圖層 > 複製影格',
        placement: 'MenuBar',
        name: '複製影格',
    },
    {
        id: 6355,
        label: '圖層 > 視訊圖層 > 刪除影格',
        placement: 'MenuBar',
        name: '刪除影格',
    },
    {
        id: 6356,
        label: '圖層 > 視訊圖層 > 解譯素材...',
        placement: 'MenuBar',
        name: '解譯素材...',
    },
    {
        id: 6357,
        label: '圖層 > 視訊圖層 > 取代素材...',
        placement: 'MenuBar',
        name: '取代素材...',
    },
    {
        id: 6358,
        label: '圖層 > 視訊圖層 > 顯示變更的視訊',
        placement: 'MenuBar',
        name: '顯示變更的視訊',
    },
    {
        id: 6360,
        label: '圖層 > 視訊圖層 > 復原影格',
        placement: 'MenuBar',
        name: '復原影格',
    },
    {
        id: 6361,
        label: '圖層 > 視訊圖層 > 復原全部影格',
        placement: 'MenuBar',
        name: '復原全部影格',
    },
    {
        id: 6362,
        label: '檔案 > 讀入 > 視訊影格到圖層...',
        placement: 'MenuBar',
        name: '視訊影格到圖層...',
    },
    {
        id: 6363,
        label: '圖層 > 視訊圖層 > 重新載入影格',
        placement: 'MenuBar',
        name: '重新載入影格',
    },
    {
        id: 6400,
        label: '檢視 > 32 位元預視選項...',
        placement: 'MenuBar',
        name: '32 位元預視選項...',
    },
    {
        id: 6432,
        label: '圖層 > 智慧型物件 > 堆疊模式 > 無',
        placement: 'MenuBar',
        name: '無',
    },
    {
        id: 6440,
        label: '濾鏡 > 轉換成智慧型濾鏡',
        placement: 'MenuBar',
        name: '轉換成智慧型濾鏡',
    },
    {
        id: 6478,
        label: '視窗 > 內容',
        placement: 'MenuBar',
        name: '內容',
    },
    {
        id: 6479,
        label: '視窗 > 調整',
        placement: 'MenuBar',
        name: '調整',
    },
    {
        id: 6651,
        label: '圖層 > 新增調整圖層 > 清晰度和去朦朧…',
        placement: 'MenuBar',
        name: '清晰度和去朦朧…',
    },
    {
        id: 6652,
        label: '圖層 > 新增調整圖層 > 顆粒…',
        placement: 'MenuBar',
        name: '顆粒…',
    },
    {
        id: 7763,
        label: '視窗 > 漸層',
        placement: 'MenuBar',
        name: '漸層',
    },
    {
        id: 7767,
        label: '視窗 > 圖樣',
        placement: 'MenuBar',
        name: '圖樣',
    },
    {
        id: 7772,
        label: '視窗 > 形狀',
        placement: 'MenuBar',
        name: '形狀',
    },
    {
        id: 7785,
        label: '視窗 > Content Credentials (Beta)',
        placement: 'MenuBar',
        name: 'Content Credentials (Beta)',
    },
    {
        id: 7788,
        label: '視窗 > 材質',
        placement: 'MenuBar',
        name: '材質',
    },
    {
        id: 7789,
        label: '濾鏡 > 參數型濾鏡…',
        placement: 'MenuBar',
        name: '參數型濾鏡…',
    },
    {
        id: 7800,
        label: '影像 > 套用資料集...',
        placement: 'MenuBar',
        name: '套用資料集...',
    },
    {
        id: 7802,
        label: '影像 > 變數 > 定義...',
        placement: 'MenuBar',
        name: '定義...',
    },
    {
        id: 7803,
        label: '影像 > 變數 > 資料集...',
        placement: 'MenuBar',
        name: '資料集...',
    },
    {
        id: 7805,
        label: '檔案 > 讀入 > 變數資料集...',
        placement: 'MenuBar',
        name: '變數資料集...',
    },
    {
        id: 7806,
        label: '檔案 > 轉存 > 資料集做為檔案...',
        placement: 'MenuBar',
        name: '資料集做為檔案...',
    },
    {
        id: 7900,
        label: '影像 > 分析 > 計算工具',
        placement: 'MenuBar',
        name: '計算工具',
    },
    {
        id: 7930,
        label: '視窗 > 應用程式框架',
        placement: 'MenuBar',
        name: '應用程式框架',
    },
    {
        id: 8820,
        label: '濾鏡 > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: '文字 > 面板 > 字元樣式面板',
        placement: 'MenuBar',
        name: '字元樣式面板',
    },
    {
        id: 9066,
        label: '視窗 > 字元樣式',
        placement: 'MenuBar',
        name: '字元樣式',
    },
    {
        id: 9067,
        label: '文字 > 面板 > 段落樣式面板',
        placement: 'MenuBar',
        name: '段落樣式面板',
    },
    {
        id: 9067,
        label: '視窗 > 段落樣式',
        placement: 'MenuBar',
        name: '段落樣式',
    },
    {
        id: 9068,
        label: '文字 > 面板 > 字符面板',
        placement: 'MenuBar',
        name: '字符面板',
    },
    {
        id: 9068,
        label: '視窗 > 字符',
        placement: 'MenuBar',
        name: '字符',
    },
    {
        id: 9086,
        label: '文字 > OpenType > 齊行替代字',
        placement: 'MenuBar',
        name: '齊行替代字',
    },
    {
        id: 9087,
        label: '文字 > 管理遺失字體',
        placement: 'MenuBar',
        name: '管理遺失字體',
    },
    {
        id: 9100,
        label: '文字 > 語言選項 > 預設功能',
        placement: 'MenuBar',
        name: '預設功能',
    },
    {
        id: 9101,
        label: '文字 > 語言選項 > 東亞功能',
        placement: 'MenuBar',
        name: '東亞功能',
    },
    {
        id: 9102,
        label: '文字 > 語言選項 > 中東功能',
        placement: 'MenuBar',
        name: '中東功能',
    },
    {
        id: 9109,
        label: '文字 > 字體預視大小 > 無',
        placement: 'MenuBar',
        name: '無',
    },
    {
        id: 9110,
        label: '文字 > 字體預視大小 > 小',
        placement: 'MenuBar',
        name: '小',
    },
    {
        id: 9111,
        label: '文字 > 字體預視大小 > 中',
        placement: 'MenuBar',
        name: '中',
    },
    {
        id: 9112,
        label: '文字 > 字體預視大小 > 大',
        placement: 'MenuBar',
        name: '大',
    },
    {
        id: 9113,
        label: '文字 > 字體預視大小 > 特大',
        placement: 'MenuBar',
        name: '特大',
    },
    {
        id: 9114,
        label: '文字 > 字體預視大小 > 巨大',
        placement: 'MenuBar',
        name: '巨大',
    },
    {
        id: 9119,
        label: '文字 > 貼上 Lorem Ipsum',
        placement: 'MenuBar',
        name: '貼上 Lorem Ipsum',
    },
    {
        id: 9121,
        label: '文字 > 載入預設文字樣式',
        placement: 'MenuBar',
        name: '載入預設文字樣式',
    },
    {
        id: 9122,
        label: '文字 > 儲存預設文字樣式',
        placement: 'MenuBar',
        name: '儲存預設文字樣式',
    },
    {
        id: 9123,
        label: '文字 > 符合字體...',
        placement: 'MenuBar',
        name: '符合字體...',
    },
    {
        id: 9130,
        label: '文字 > 語言選項 > 標準垂直羅馬字對齊方式',
        placement: 'MenuBar',
        name: '標準垂直羅馬字對齊方式',
    },
    {
        id: 9131,
        label: '文字 > 語言選項 > 直排內橫排',
        placement: 'MenuBar',
        name: '直排內橫排',
    },
    {
        id: 9132,
        label: '文字 > 語言選項 > 前一行頂端到次行頂端的行距',
        placement: 'MenuBar',
        name: '前一行頂端到次行頂端的行距',
    },
    {
        id: 9133,
        label: '文字 > 語言選項 > 前一行底部到次行底部的行距',
        placement: 'MenuBar',
        name: '前一行底部到次行底部的行距',
    },
    {
        id: 9137,
        label: '文字 > 語言選項 > Kashida',
        placement: 'MenuBar',
        name: 'Kashida',
    },
    {
        id: 9138,
        label: '文字 > 語言選項 > 預設方向',
        placement: 'MenuBar',
        name: '預設方向',
    },
    {
        id: 9139,
        label: '文字 > 語言選項 > 由左至右字元方向',
        placement: 'MenuBar',
        name: '由左至右字元方向',
    },
    {
        id: 9140,
        label: '文字 > 語言選項 > 由右至左字元方向',
        placement: 'MenuBar',
        name: '由右至左字元方向',
    },
    {
        id: 9143,
        label: '編輯 > 選擇性貼上 > 貼上且不使用任何格式',
        placement: 'MenuBar',
        name: '貼上且不使用任何格式',
    },
    {
        id: 9220,
        label: '圖層 > 新增 > 工作區域...',
        placement: 'MenuBar',
        name: '工作區域...',
    },
    {
        id: 9221,
        label: '圖層 > 新增 > 來自群組的工作區域',
        placement: 'MenuBar',
        name: '來自群組的工作區域',
    },
    {
        id: 9222,
        label: '圖層 > 新增 > 來自圖層的工作區域...',
        placement: 'MenuBar',
        name: '來自圖層的工作區域...',
    },
    {
        id: 9252,
        label: '圖層 > 新增 > 來自圖層的邊框...',
        placement: 'MenuBar',
        name: '來自圖層的邊框...',
    },
    {
        id: 9255,
        label: '圖層 > 新增 > 轉換為邊框',
        placement: 'MenuBar',
        name: '轉換為邊框',
    },
    {
        id: 9600,
        label: '視窗 > 相關工作列',
        placement: 'MenuBar',
        name: '相關工作列',
    },
    {
        id: 11600,
        label: '圖層 > 調和',
        placement: 'MenuBar',
        name: '調和',
    },
    {
        id: 15004,
        label: '說明 > 系統資訊...',
        placement: 'MenuBar',
        name: '系統資訊...',
    },
    {
        id: 15009,
        label: '說明 > GPU 相容性...',
        placement: 'MenuBar',
        name: 'GPU 相容性...',
    },
    {
        id: 15019,
        label: '說明 > 深入瞭解生成式點數',
        placement: 'MenuBar',
        name: '深入瞭解生成式點數',
    },
    {
        id: 15020,
        label: '說明 > Adobe 生成式 AI 使用者原則',
        placement: 'MenuBar',
        name: 'Adobe 生成式 AI 使用者原則',
    },
    {
        id: 15201,
        label: '檔案 > 搜尋 Adobe 庫存...',
        placement: 'MenuBar',
        name: '搜尋 Adobe 庫存...',
    },
    {
        id: 15202,
        label: '檔案 > 搜尋 Adobe Express 範本…',
        placement: 'MenuBar',
        name: '搜尋 Adobe Express 範本…',
    },
    {
        id: 15203,
        label: '說明 > 實作教學課程...',
        placement: 'MenuBar',
        name: '實作教學課程...',
    },
    {
        id: 15204,
        label: '說明 > 新增功能...',
        placement: 'MenuBar',
        name: '新增功能...',
    },
    {
        id: 17001,
        label: '編輯 > 透視彎曲',
        placement: 'MenuBar',
        name: '透視彎曲',
    },
    {
        id: 20006,
        label: '檔案 > 版本記錄',
        placement: 'MenuBar',
        name: '版本記錄',
    },
    {
        id: 20007,
        label: '視窗 > 版本記錄',
        placement: 'MenuBar',
        name: '版本記錄',
    },
    {
        id: 20008,
        label: '視窗 > 註解',
        placement: 'MenuBar',
        name: '註解',
    },
    {
        id: 21000,
        label: '圖層 > 智慧型物件 > 轉換為圖層',
        placement: 'MenuBar',
        name: '轉換為圖層',
    },
    {
        id: 21001,
        label: '檢視 > 全頁顯示圖層',
        placement: 'MenuBar',
        name: '全頁顯示圖層',
    },
    {
        id: 22003,
        label: '檢視 > 參考線 > 編輯所選參考線',
        placement: 'MenuBar',
        name: '編輯所選參考線',
    },
    {
        id: 22004,
        label: '檢視 > 參考線 > 清除選取的參考線',
        placement: 'MenuBar',
        name: '清除選取的參考線',
    },
    {
        id: 22100,
        label: '圖層 > 為所有物件套用遮色片',
        placement: 'MenuBar',
        name: '為所有物件套用遮色片',
    },
    {
        id: 23150,
        label: '濾鏡 > 上次濾鏡效果',
        placement: 'MenuBar',
        name: '上次濾鏡效果',
    },
    {
        id: 23151,
        label: '濾鏡 > 上次濾鏡效果',
        placement: 'MenuBar',
        name: '上次濾鏡效果',
    },
    {
        id: 23152,
        label: '濾鏡 > 上次濾鏡效果',
        placement: 'MenuBar',
        name: '上次濾鏡效果',
    },
    {
        id: 23153,
        label: '濾鏡 > 上次濾鏡效果',
        placement: 'MenuBar',
        name: '上次濾鏡效果',
    },
    {
        id: 25070,
        label: '編輯 > 旋轉物件',
        placement: 'MenuBar',
        name: '旋轉物件',
    },
    {
        id: 26010,
        label: '編輯 > 反射移除…',
        placement: 'MenuBar',
        name: '反射移除…',
    },
    {
        id: 30900,
        label: '檔案 > 置入免費 Adobe Stock 影像…',
        placement: 'MenuBar',
        name: '置入免費 Adobe Stock 影像…',
    },
    {
        id: 'paintbrushTool',
        label: '筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: '調整筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: '鉛筆工具',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: '顏色取代工具',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: '混合器筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: '橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: '背景橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: '仿製印章工具',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: '圖樣印章工具',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: '修復筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: '步驟記錄筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: '藝術步驟記錄筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: '指尖工具',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: '模糊工具',
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: '銳利化工具',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: '加亮工具',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: '加深工具',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: '海綿工具',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: '紅眼工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: '矩形選取畫面工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: '橢圓選取畫面工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: '水平單線選取畫面工具',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: '垂直單線選取畫面工具',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: '移動工具',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: '工作區域工具',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: '套索工具',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: '選取範圍筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: '物件選取工具',
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: '多邊形套索工具',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: '磁性套索工具',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: '魔術棒工具',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: '快速選取工具',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: '裁切工具',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: '透視裁切工具',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: '切片工具',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: '切片選取工具',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: '魔術橡皮擦工具',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: '漸層工具',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: '油漆桶工具',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: '路徑選取工具',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: '直接選取工具',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: '筆型工具',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: '創意筆工具',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: '曲線筆工具',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: '增加錨點工具',
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: '刪除錨點工具',
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: '轉換點工具',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: '水平文字工具',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: '垂直文字工具',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: '水平文字遮色片工具',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: '垂直文字遮色片工具',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: '矩形工具',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: '橢圓工具',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: '三角形工具',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: '多邊形工具',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: '線條工具',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: '自訂形狀工具',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: '星形工具',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: '邊框工具',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: '滴管工具',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: '顏色取樣器工具',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: '尺標工具',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: '備註工具',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: '手形工具',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: '旋轉檢視工具',
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: '縮放顯示工具',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: '修補工具',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: '內容感知移動工具',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: '污點修復筆刷工具',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: '移除工具',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: '編輯工具列...',
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: '計算工具',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: '動作',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: '漸層',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: '樣式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: '色票',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: '圖樣',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: '色階分佈圖',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: '資訊',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: '路徑',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: '形狀',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: '工具預設集',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: '顏色',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: '色版',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: '圖層',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: '圖層構圖',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: '時間軸',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: '仿製來源',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: '度量記錄',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'HDR 預視',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: '步驟記錄',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: '導覽器',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: '字元',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: '段落',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: '字元樣式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: '段落樣式',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: '字符',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: '備註',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: '內容',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: '庫',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: '評論',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: '內容列 : 動態文字',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: '色盤 : 動態文字',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: '工具 : 動態文字',
        placement: 'Option',
    },
];
